import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
/*! License details at fancyapps.com/license */
import { isPlainObject as t } from "../utils/isPlainObject.js";
import { isString as e } from "../utils/isString.js";
import { stringToHtml as o } from "../utils/strToHtml.js";
var n = function n(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var o = new URL(t),
      n = new URLSearchParams(o.search),
      i = new URLSearchParams();
    for (var _i = 0, _arr = [].concat(_toConsumableArray(n), _toConsumableArray(Object.entries(e))); _i < _arr.length; _i++) {
      var _arr$_i = _slicedToArray(_arr[_i], 2),
        _t = _arr$_i[0],
        _o = _arr$_i[1];
      var _e = _o + "";
      if ("t" === _t) {
        var _t2 = _e.match(/((\d*)m)?(\d*)s?/);
        _t2 && i.set("start", 60 * parseInt(_t2[2] || "0") + parseInt(_t2[3] || "0") + "");
      } else i.set(_t, _e);
    }
    var l = i + "",
      s = t.match(/#t=((.*)?\d+s)/);
    return s && (l += "#t=".concat(s[1])), l;
  },
  i = {
    autoplay: !1,
    html5videoTpl: '<video class="f-html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n    <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    iframeAttr: {
      allow: "autoplay; fullscreen",
      scrolling: "auto",
      credentialless: ""
    },
    vimeo: {
      byline: 1,
      color: "00adef",
      controls: 1,
      dnt: 1,
      muted: 0
    },
    youtube: {
      controls: 1,
      enablejsapi: 1,
      nocookie: 1,
      rel: 0,
      fs: 1
    }
  },
  l = function l() {
    var l,
      s = !1;
    function a() {
      var e = null == l ? void 0 : l.getOptions().Video;
      return t(e) ? Object.assign(Object.assign({}, i), e) : i;
    }
    function r() {
      var t;
      return null === (t = null == l ? void 0 : l.getPage()) || void 0 === t ? void 0 : t.slides[0];
    }
    var c = function c(t) {
      var e;
      try {
        var _o2 = JSON.parse(t.data);
        if ("https://player.vimeo.com" === t.origin) {
          if ("ready" === _o2.event) for (var _i2 = 0, _Array$from = Array.from((null === (e = null == l ? void 0 : l.getContainer()) || void 0 === e ? void 0 : e.getElementsByClassName("f-iframe")) || []); _i2 < _Array$from.length; _i2++) {
            var _o3 = _Array$from[_i2];
            _o3 instanceof HTMLIFrameElement && _o3.contentWindow === t.source && (_o3.dataset.ready = "true");
          }
        } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === _o2.event) {
          var _t3 = document.getElementById(_o2.id);
          _t3 && (_t3.dataset.ready = "true");
        }
      } catch (t) {}
    };
    function d(t, o) {
      var i = o.src;
      if (!e(i)) return;
      var l = o.type;
      if (!l || "html5video" === l) {
        var _t4 = i.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i);
        _t4 && (l = "html5video", o.html5videoFormat = o.html5videoFormat || "video/" + ("ogv" === _t4[1] ? "ogg" : _t4[1]));
      }
      if (!l || "youtube" === l) {
        var _t5 = i.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i);
        if (_t5) {
          var _e2 = Object.assign(Object.assign({}, a().youtube), o.youtube || {}),
            _s = "www.youtube".concat(_e2.nocookie ? "-nocookie" : "", ".com"),
            _r = n(i, _e2),
            _c = encodeURIComponent(_t5[2]);
          o.videoId = _c, o.src = "https://".concat(_s, "/embed/").concat(_c, "?").concat(_r), o.thumb = o.thumb || "https://i.ytimg.com/vi/".concat(_c, "/mqdefault.jpg"), l = "youtube";
        }
      }
      if (!l || "vimeo" === l) {
        var _t6 = i.match(/^.+vimeo.com\/(?:\/)?(video\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/);
        if (_t6) {
          var _e3 = Object.assign(Object.assign({}, a().vimeo), o.vimeo || {}),
            _s2 = n(i, _e3),
            _r2 = encodeURIComponent(_t6[2]),
            _c2 = _t6[5] || "";
          o.videoId = _r2, o.src = "https://player.vimeo.com/video/".concat(_r2, "?").concat(_c2 ? "h=".concat(_c2).concat(_s2 ? "&" : "") : "").concat(_s2), l = "vimeo";
        }
      }
      o.type = l;
    }
    function u(t, n) {
      "html5video" === n.type && function (t) {
        if (!l || !t.el || !t.src) return;
        var n = t.el,
          i = t.src;
        if (!n || !i) return;
        var s = t.html5videoTpl || a().html5videoTpl,
          r = t.html5videoFormat || a().html5videoFormat;
        if (!s) return;
        var c = t.poster || (t.thumb && e(t.thumb) ? t.thumb : ""),
          d = o(s.replace(/\{\{src\}\}/gi, i + "").replace(/\{\{format\}\}/gi, r || "").replace(/\{\{poster\}\}/gi, c + ""));
        if (!d) return;
        var u = document.createElement("div");
        u.classList.add("f-html"), u.append(d), t.contentEl = d, t.htmlEl = u, n.classList.add("has-".concat(t.type)), n.prepend(u), h(t), l.emit("contentReady", t);
      }(n), "youtube" !== n.type && "vimeo" !== n.type || function (t) {
        if (!l || !t.el || !t.src) return;
        var e = document.createElement("iframe");
        e.classList.add("f-iframe"), e.setAttribute("id", "f-iframe_".concat(t.videoId));
        for (var _i3 = 0, _Object$entries = Object.entries(a().iframeAttr || {}); _i3 < _Object$entries.length; _i3++) {
          var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
            _t7 = _Object$entries$_i[0],
            _o4 = _Object$entries$_i[1];
          e.setAttribute(_t7, _o4);
        }
        e.onload = function () {
          var o;
          l && 1 === l.getState() && "youtube" === t.type && (null === (o = e.contentWindow) || void 0 === o || o.postMessage(JSON.stringify({
            event: "listening",
            id: e.getAttribute("id")
          }), "*"));
        }, e.onerror = function () {
          l && 1 === l.getState() && (null == l || l.showError(t, "{{IFRAME_ERROR}}"));
        }, e.src = t.src;
        var o = document.createElement("div");
        o.classList.add("f-html"), o.append(e), t.contentEl = e, t.htmlEl = o, t.el.classList.add("has-html"), t.el.classList.add("has-iframe"), t.el.classList.add("has-".concat(t.type)), t.el.prepend(o), h(t), l.emit("contentReady", t);
      }(n);
    }
    function m(t, e) {
      var o, n;
      "html5video" !== e.type && "youtube" !== e.type && "vimeo" !== e.type || (null === (o = e.contentEl) || void 0 === o || o.remove(), e.contentEl = void 0, null === (n = e.htmlEl) || void 0 === n || n.remove(), e.htmlEl = void 0), e.poller && clearTimeout(e.poller);
    }
    function f() {
      s = !1;
    }
    function p() {
      if (s) return;
      s = !0;
      var t = r();
      (t && void 0 !== t.autoplay ? t.autoplay : a().autoplay) && (function () {
        var t;
        var e = r(),
          o = null == e ? void 0 : e.el;
        if (o && "html5video" === (null == e ? void 0 : e.type)) try {
          var _t8 = o.querySelector("video");
          if (_t8) {
            var _e4 = _t8.play();
            void 0 !== _e4 && _e4.then(function () {}).catch(function (e) {
              _t8.muted = !0, _t8.play();
            });
          }
        } catch (t) {}
        var n = null == e ? void 0 : e.htmlEl;
        n instanceof HTMLIFrameElement && (null === (t = n.contentWindow) || void 0 === t || t.postMessage('{"event":"command","func":"stopVideo","args":""}', "*"));
      }(), function () {
        var t = r(),
          e = null == t ? void 0 : t.type;
        if (!(null == t ? void 0 : t.el) || "youtube" !== e && "vimeo" !== e) return;
        var _o5 = function o() {
          if (t.contentEl && t.contentEl instanceof HTMLIFrameElement && t.contentEl.contentWindow) {
            var _e5;
            if ("true" === t.contentEl.dataset.ready) return _e5 = "youtube" === t.type ? {
              event: "command",
              func: "playVideo"
            } : {
              method: "play",
              value: "true"
            }, _e5 && t.contentEl.contentWindow.postMessage(JSON.stringify(_e5), "*"), void (t.poller = void 0);
            "youtube" === t.type && (_e5 = {
              event: "listening",
              id: t.contentEl.getAttribute("id")
            }, t.contentEl.contentWindow.postMessage(JSON.stringify(_e5), "*"));
          }
          t.poller = setTimeout(_o5, 250);
        };
        _o5();
      }());
    }
    function h(t) {
      var e = null == t ? void 0 : t.htmlEl;
      if (t && e && ("html5video" === t.type || "youtube" === t.type || "vimeo" === t.type)) {
        if (e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.style.maxWidth = "", e.style.maxHeight = "", t.width) {
          var _o6 = "".concat(t.width);
          _o6.match(/^\d+$/) && (_o6 += "px"), e.style.maxWidth = "".concat(_o6);
        }
        if (t.height) {
          var _o7 = "".concat(t.height);
          _o7.match(/^\d+$/) && (_o7 += "px"), e.style.maxHeight = "".concat(_o7);
        }
        if (t.aspectRatio) {
          var _o8 = t.aspectRatio.split("/"),
            _n = parseFloat(_o8[0].trim()),
            _i4 = _o8[1] ? parseFloat(_o8[1].trim()) : 0,
            _l = _n && _i4 ? _n / _i4 : _n;
          e.offsetHeight;
          var _s3 = e.getBoundingClientRect(),
            _a = _l < (_s3.width || 1) / (_s3.height || 1);
          e.style.aspectRatio = "".concat(t.aspectRatio), e.style.width = _a ? "auto" : "", e.style.height = _a ? "" : "auto";
        }
      }
    }
    function v() {
      h(r());
    }
    return {
      init: function init(t) {
        l = t, l.on("addSlide", d), l.on("attachSlideEl", u), l.on("detachSlideEl", m), l.on("ready", p), l.on("change", f), l.on("settle", p), l.on("refresh", v), window.addEventListener("message", c);
      },
      destroy: function destroy() {
        null == l || l.off("addSlide", d), null == l || l.off("attachSlideEl", u), null == l || l.off("detachSlideEl", m), null == l || l.off("ready", p), null == l || l.off("change", f), null == l || l.off("settle", p), null == l || l.off("refresh", v), window.removeEventListener("message", c), l = void 0;
      }
    };
  };
export { l as Video };